import { render } from "./Inflation.vue?vue&type=template&id=8776e774&scoped=true&ts=true"
import script from "./Inflation.vue?vue&type=script&lang=ts"
export * from "./Inflation.vue?vue&type=script&lang=ts"

import "./Inflation.vue?vue&type=style&index=0&id=8776e774&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8776e774"]])

export default __exports__